<template>
  <div>
    <activity-package-period-detail
      v-if="isActivity"
      :detail="detail"
    />
    <template v-else>
      <el-descriptions
        :column="3"
        border
        size="small"
      >
        <el-descriptions-item label="编码">
          {{ detail.packCode }}
        </el-descriptions-item>
        <el-descriptions-item label="名称">
          {{ detail.packName }}
        </el-descriptions-item>
        <el-descriptions-item label="发货周期">
          {{ packageText(detail) }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="detail.versionNo"
          label="计算版本"
        >
          {{ detail.versionNo }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="detail.calculateTime"
          label="计算时间"
        >
          {{ detail.calculateTime }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="detail.ruleVersion"
          label="规则版本"
        >
          {{ detail.ruleVersion }}
        </el-descriptions-item>
      </el-descriptions>

      <el-alert
        v-if="detail.exceptionMessage"
        :title="detail.exceptionMessage"
        type="warning"
        :closable="false"
        class="detail-block"
      />
      <el-alert
        v-if="detail.fallbackFlag === 1"
        :title="'已使用历史版本兜底：' + (detail.sourceVersionNo || '—')"
        type="warning"
        :closable="false"
        class="detail-block"
      />

      <el-descriptions
        :column="3"
        border
        size="small"
        class="detail-block"
      >
        <el-descriptions-item label="上架分类">
          {{ detail.lifeCycleTypeName }}
        </el-descriptions-item>
        <el-descriptions-item label="生产物流分类">
          {{ detail.productionLogisticsTypeName }}
        </el-descriptions-item>
        <el-descriptions-item label="供应渠道">
          {{ detail.supplyChannelName }}
        </el-descriptions-item>
      </el-descriptions>

      <div
        v-for="(hit, index) in detail.ruleHits || []"
        :key="index"
        class="detail-block"
      >
        <p>
          {{ hit.dimensionName }} · {{ hit.priorityCode }} · {{ hit.ruleDesc }}
          → {{ periodText(hit.resultCycle) }}（规则版本 {{ hit.ruleVersion }}）
        </p>
        <p v-if="hit.formulaDesc">
          {{ hit.formulaDesc }}
        </p>
        <el-table
          :data="hit.nodes || []"
          border
          size="small"
        >
          <el-table-column
            prop="fieldName"
            label="判断字段"
            min-width="160"
          />
          <el-table-column
            prop="actualNumber"
            label="实际值"
          />
          <el-table-column
            prop="operatorCode"
            label="关系"
          />
          <el-table-column
            prop="thresholdNumber"
            label="阈值"
          />
          <el-table-column
            prop="thresholdUnitName"
            label="单位"
          />
          <el-table-column label="判断结果">
            <template slot-scope="scope">
              {{ scope.row.matchFlag === 1 ? '命中' : '未命中' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="message"
            label="说明"
            min-width="200"
          />
        </el-table>
      </div>

      <el-table
        :data="detail.inputFields || []"
        border
        size="small"
        class="detail-block"
        empty-text="暂无参与计算数据"
      >
        <el-table-column
          prop="fieldName"
          label="参与字段"
        />
        <el-table-column
          prop="value"
          label="取值"
        />
      </el-table>

      <el-table
        v-if="(detail.exceptionDetails || []).length"
        :data="detail.exceptionDetails"
        border
        size="small"
        class="detail-block"
      >
        <el-table-column
          prop="dimensionName"
          label="维度"
        />
        <el-table-column
          prop="exceptionMessage"
          label="异常原因"
        />
      </el-table>
    </template>
  </div>
</template>

<script>
import { packageText, periodText } from '../model'
import ActivityPackagePeriodDetail from './ActivityPackagePeriodDetail'

export default {
  name: 'PackagePeriodDetail',
  components: {
    ActivityPackagePeriodDetail
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    configType: {
      type: String,
      default: 'BASIC'
    }
  },
  computed: {
    isActivity () {
      return this.configType === 'ACTIVITY'
    }
  },
  methods: {
    packageText,
    periodText
  }
}
</script>

<style scoped>
.detail-block {
  margin-top: 16px;
}
</style>
